module.exports = __webpack_public_path__ + "static/media/logo.1ef9f46c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo.png
// module id = 1098
// module chunks = 0